<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>居住地和户籍地不一致的人口</div>
      <div class="twos">
        <div class="one">
          <span>{{ rows.czwlrk }}</span><span>(人)</span>
          <div>居住地和户籍地不一致的总人口</div>
        </div>
        <!-- <div class="one aa">
          <span>31476</span><span>(人)</span>
          <div>男性人数</div>
        </div>
        <div class="one bb">
          <span>32434</span><span>(人)</span>
          <div>女性人口</div>
        </div> -->
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>人户分离人口离开户口登记地原因</p>
      <div ref="echartsINof" class="echarts" style="height: 55vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj,czrk } from "@/network";
export default {
  data() {
    return {
      name: "工作就业",
      rows: {},
    };
  },
  created() {},
  mounted() {
    this.getInfoList();
    this.getname();
    this.getInfoData()
    // this.handEchart();
  },
  methods: {
    async getInfoList() {
      const { code, rows, total } = await czrk({villagesCode: "110105011"});
      this.rows = rows[0];
    },
    getname() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      myechart.on("legendselectchanged", (params) => {
        // console.log(params.name);
        this.name = params.name;
        this.getInfoData();
      });
    },
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_jzdhhjdbyzdrk",
        streetCode: "110105011",
        isOutside:0
      });
      var compare = function (attribute) {
        return function (obj1, obj2) {
          var val1 = obj1[attribute];
          var val2 = obj2[attribute];
          // if (val1 < val2) {
          //   return 1;
          // } else if (val1 > val2) {
          //   return -1;
          // } else {
          //   return 0;
          // }
        };
      };
      if(this.name=="工作就业"){
        let datas = data.sort(compare("gzjy")); //通过Id排序完成后的数组
      }else if(this.name=="学习培训"){
        let datas = data.sort(compare("xxpx")); //通过Id排序完成后的数组
      }else if(this.name=="随同离开/投亲靠友"){
        let datas = data.sort(compare("stlk")); //通过Id排序完成后的数组
      }else if(this.name=="拆迁/搬家"){
        let datas = data.sort(compare("cq")); //通过Id排序完成后的数组
      }else if(this.name=="寄挂户口"){
        let datas = data.sort(compare("jghk")); //通过Id排序完成后的数组
      }else if(this.name=="婚姻嫁娶"){
        let datas = data.sort(compare("hyjq")); //通过Id排序完成后的数组
      }else if(this.name=="照料子女"){
        let datas = data.sort(compare("zlszn")); //通过Id排序完成后的数组
      }else if(this.name=="为子女就学"){
        let datas = data.sort(compare("wznjx")); //通过Id排序完成后的数组
      }else if(this.name=="养老/康养"){
        let datas = data.sort(compare("yl")); //通过Id排序完成后的数组
      }else{
        let datas = data.sort(compare("qt")); //通过Id排序完成后的数组
      }
      // console.log(data)
      let czrk = [];
      let villages_name = [];
      let gzjy = [];
      let xxpx = [];
      let stlk = [];
      let cq = [];
      let jghk = [];
      let hyjq = [];
      let zlszn = [];
      let wznjx = [];
      let yl = [];
      let qt = [];
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        gzjy.push(item.gzjy);
        xxpx.push(item.xxpx);
        stlk.push(item.stlk);
        cq.push(item.cq);
        jghk.push(item.jghk);
        hyjq.push(item.hyjq);
        zlszn.push(item.zlszn);
        wznjx.push(item.wznjx);
        yl.push(item.yl);
        qt.push(item.qt);
      }
      this.handEchart(czrk,villages_name,gzjy,xxpx,stlk,cq,jghk,hyjq,zlszn,wznjx,yl,qt)
    },
    handEchart(e,es,gzjy,xxpx,stlk,cq,jghk,hyjq,zlszn,wznjx,yl,qt) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
         legend: {
          selectedMode: "single", //取消图例的点击事件
          textStyle:{
          color:"#fff",
        },
        },
        textStyle:{
          color:"#fff"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          top: "30%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: es,
            axisLabel: { interval: 0, rotate: 60 }
          },
          
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "工作就业",
            type: "bar",
            // barWidth:'50%',
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: gzjy,
          },
          {
            name: "学习培训",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: xxpx,
          },
          {
            name: "随同离开/投亲靠友",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: stlk,
          },
          {
            name: "拆迁/搬家",
            type: "bar",
            stack: "Ad",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: cq,
          },
          {
            name: "寄挂户口",
            type: "bar",
            stack: "Search Engine",
            data: jghk,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "婚姻嫁娶",
            type: "bar",
            // barWidth: 5,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: hyjq,
          },
          {
            name: "照料孙子女",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: zlszn,
          },
          {
            name: "为子女就学",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: wznjx,
          },
          {
            name: "养老/康养",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data:yl,
          },
          {
            name: "其他",
            type: "bar",
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            data: qt,
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 2vh;
    }
    .echarts{
        margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .twos {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
